<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('user.support.viewtitle')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>

        <div class="form new-ticket__form" v-show="showNewTicketForm">

          <support-form></support-form>

        </div>
        <support-ticket-section v-if="!showNewTicketForm && !showDetailPage"></support-ticket-section>
        <support-ticket-detail v-show="showDetailPage"></support-ticket-detail>
      </b-col>
    </b-row>
    <b-row v-if="!showNewTicketForm && !showDetailPage" align-h="end" class="contentcontainer__footer">
      <b-col cols="auto">
        <button class="btn btn--primary" v-if="!showNewTicketForm" v-on:click="showSupportNewTicketForm()">{{$t('user.support.newticket')}}</button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapMutations, mapState } from 'vuex'
import SupportForm from './SupportForm'
import SupportTicketSection from './SupportTicketSection'
import SupportTicketDetail from './SupportTicketDetail'

export default {

  name: 'Support',

  components: {
    SupportTicketSection,
    SupportTicketDetail,
    SupportForm
  },

  computed: {
    ...mapState('support', [
      'tags',
      'tickets',
      'showNewTicketForm',
      'showDetailPage'
    ])
  },

  methods: {
    ...mapMutations('support', [
      'showSupportNewTicketForm',
      'closeSupportNewTicketForm'
    ]),

    submitForm () {
      this.closeSupportNewTicketForm()
    }
  }
}
</script>
